<script>
import NotificationCenter from './components/kit/NotificationCenter.vue';
import BouncingDots from './components/kit/BouncingDots.vue';

export default {
  name: 'App',
  components: { NotificationCenter, BouncingDots },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
};
</script>

<template>
  <div class="relative">
    <div class="flex text-gray-500 my-24 md:my-56 justify-center" v-if="isLoading">
      <span>
        {{ $t('appLoading') }}
        <BouncingDots class="ml-1 text-xl" />
      </span>
    </div>
    <router-view v-else></router-view>
    <NotificationCenter />
  </div>
</template>
